
import { ClientFormData, QuestionnaireData, StorableOrder } from '@/types/formTypes';

// Generate a unique UUID
const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

// Get or create a chat ID
export const getChatId = () => {
  let chatId = localStorage.getItem('chatId');
  if (!chatId) {
    chatId = generateUUID();
    localStorage.setItem('chatId', chatId);
  }
  return chatId;
};

// Define chat message sending functions
export const sendChatMessageToN8n = async (message: string, metadata: any = {}) => {
  try {
    console.log('Sending chat message to n8n:', message);
    const webhookUrl = metadata.webhookUrl || 'https://cvproquebec.app.n8n.cloud/webhook/ChatManonBot';
    const chatId = getChatId();
    
    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        chatId,
        message,
        ...metadata
      })
    });
    
    if (!response.ok) {
      console.error(`HTTP error! Status: ${response.status}`);
      return { success: false, error: `HTTP error! Status: ${response.status}` };
    }
    
    // Essai de traiter la réponse comme JSON
    try {
      const data = await response.json();
      console.log('n8n webhook response data:', data);
      return { 
        success: true, 
        response: data.response || data.output?.text || data.text || data.message || JSON.stringify(data) 
      };
    } catch (jsonError) {
      // Si la réponse n'est pas du JSON valide, renvoyer le texte brut
      const text = await response.text();
      console.log('n8n webhook raw response:', text);
      return { success: true, response: text };
    }
  } catch (error) {
    console.error('Error sending chat message to n8n:', error);
    return { success: false, error: String(error) };
  }
};

export const sendTelegramMessageViaWebhook = async (message: string) => {
  try {
    console.log('Sending Telegram message via webhook:', message);
    const webhookUrl = 'https://cvproquebec.app.n8n.cloud/webhook/telegram';
    const chatId = getChatId();
    
    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        chatId,
        message,
        platform: 'telegram'
      })
    });
    
    if (!response.ok) {
      console.error(`HTTP error! Status: ${response.status}`);
      return { success: false, error: `HTTP error! Status: ${response.status}` };
    }
    
    // Essai de traiter la réponse comme JSON avec gestion des erreurs améliorée
    try {
      const data = await response.json();
      console.log('Telegram webhook response data:', data);
      return { 
        success: true, 
        response: data.response || data.output?.text || data.text || data.message || JSON.stringify(data) 
      };
    } catch (jsonError) {
      // Si la réponse n'est pas du JSON valide, renvoyer le texte brut
      const text = await response.text();
      console.log('Telegram webhook raw response:', text);
      return { success: true, response: text };
    }
  } catch (error) {
    console.error('Error sending Telegram message:', error);
    return { success: false, error: String(error) };
  }
};

// Save order data to localStorage
export const saveOrderToLocalStorage = (
  formData: ClientFormData,
  questionnaireData?: QuestionnaireData,
  submittedAt?: string
) => {
  try {
    // Generate a timestamp if not provided
    const timestamp = submittedAt || new Date().toISOString();
    
    // Get existing orders from localStorage
    const existingOrdersString = localStorage.getItem('submittedOrders');
    const existingOrders: StorableOrder[] = existingOrdersString 
      ? JSON.parse(existingOrdersString) 
      : [];
    
    // Create new order object
    const orderNumber = formData.orderNumber || `ORD${Date.now()}`;
    const newOrder: StorableOrder = {
      formData: {
        ...formData,
        orderNumber
      },
      questionnaireData,
      submittedAt: timestamp,
      orderNumber
    };
    
    // Add new order to the beginning of the array
    const updatedOrders = [newOrder, ...existingOrders];
    
    // Save back to localStorage
    localStorage.setItem('submittedOrders', JSON.stringify(updatedOrders));
    
    console.log('Order saved to localStorage successfully');
    return true;
  } catch (error) {
    console.error('Error saving order to localStorage', error);
    return false;
  }
};

// Get submitted orders from localStorage
export const getSubmittedOrders = (): StorableOrder[] => {
  try {
    const ordersString = localStorage.getItem('submittedOrders');
    return ordersString ? JSON.parse(ordersString) : [];
  } catch (error) {
    console.error('Error retrieving orders from localStorage', error);
    return [];
  }
};
